import { axios } from './index'
import { URL_ADMIN_LOGIN } from '../constants'

import type { DataAuthType } from '../types/auth'

export const signIn = async (data: DataAuthType) => {
  try {
    const response = await axios.post(URL_ADMIN_LOGIN, data)
    return response
  } catch (error) {
    console.error('Sign-in error:', error)
    throw error
  }
}
